<div class="perf-details-page">
  <div class="page-head">
    <button type="button" class="back-btn" (click)="goBack()" aria-label="Back to Team Dashboard">
      ← Back to Team Dashboard
    </button>
    <h2 class="page-title">
      Performance Rating —
      {{ activeQuarter === 'Q2' ? 'Mid Year' : (activeQuarter === 'Q4' ? 'Year End' : activeQuarter) }}
      {{ activeYear }}
    </h2>
    <div class="page-sub">
      {{ filteredRows.length }} {{ filteredRows.length === 1 ? 'entry' : 'entries' }}
      <span *ngIf="hasFilters"> · filtered</span>
    </div>
  </div>

  <div class="filters-bar">
    <div class="filter-row">
      <div class="quarter-chips" role="tablist" aria-label="Quarter">
        <button
          *ngFor="let chip of quarterChips"
          type="button"
          role="tab"
          class="chip"
          [class.chip--active]="activeQuarter === chip.value"
          [attr.aria-selected]="activeQuarter === chip.value"
          (click)="onQuarterChange(chip.value)"
        >
          {{ chip.label }}
        </button>
      </div>
      <select
        class="year-select"
        aria-label="Year"
        [ngModel]="activeYear"
        (ngModelChange)="onYearChange($event)"
      >
        <option *ngFor="let y of yearOptions" [ngValue]="y">{{ y }}</option>
      </select>
      <button
        *ngIf="hasFilters"
        type="button"
        class="clear-btn"
        (click)="clearFilters()"
      >Clear filters</button>
    </div>

    <div class="filter-row filter-row--dropdowns" *ngIf="rows.length > 0">
      <label>
        L3 Leader:
        <select [(ngModel)]="l3Filter" (ngModelChange)="onL3Change()">
          <option value="">All L3 Leaders</option>
          <option *ngFor="let n of l3Options" [value]="n">{{ n }}</option>
        </select>
      </label>
      <label>
        L4 Leader:
        <select [(ngModel)]="l4Filter" (ngModelChange)="onL4Change()">
          <option value="">All L4 Leaders</option>
          <option *ngFor="let n of l4Options" [value]="n">{{ n }}</option>
        </select>
      </label>
      <label>
        L5 Leader:
        <select [(ngModel)]="l5Filter" (ngModelChange)="onL5Change()">
          <option value="">All L5 Leaders</option>
          <option *ngFor="let n of l5Options" [value]="n">{{ n }}</option>
        </select>
      </label>
      <label>
        Rating:
        <select [(ngModel)]="ratingFilter" (ngModelChange)="onRatingChange()">
          <option *ngFor="let opt of ratingOptions" [value]="opt.value">{{ opt.label }}</option>
        </select>
      </label>
    </div>
  </div>

  <div class="page-body">
    <div class="loading" *ngIf="loading">Loading…</div>
    <div class="error" *ngIf="loadError">Failed to load feedback list.</div>

    <table class="feedback-table" *ngIf="!loading && !loadError && filteredRows.length > 0">
      <thead>
        <tr>
          <th class="col-empid">Employee ID</th>
          <th class="col-name">Employee</th>
          <th class="col-mgr">Reporting Manager</th>
          <th class="col-l3">L3 Leader</th>
          <th class="col-l4">L4 Leader</th>
          <th class="col-l5">L5 Leader</th>
          <th class="col-rating">Rating</th>
          <th class="col-action">Action</th>
          <th class="col-comments">Comments</th>
          <th class="col-submitted">Submitted</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of pagedRows">
          <td class="col-empid">{{ row.employeeId }}</td>
          <td class="col-name">{{ row.employeeName }}</td>
          <td class="col-mgr">{{ row.reportingManagerName || '—' }}</td>
          <td class="col-l3">{{ row.l3Name || '—' }}</td>
          <td class="col-l4">{{ row.l4Name || '—' }}</td>
          <td class="col-l5">{{ row.l5Name || '—' }}</td>
          <td class="col-rating">
            <span class="rating-pill" [attr.data-rating]="row.performanceRating || 'UNRATED'">
              {{ ratingLabel(row.performanceRating) }}
            </span>
          </td>
          <td class="col-action">
            <button
              type="button"
              class="action-btn"
              (click)="openContractorProfile(row.employeeId)"
              [title]="row.performanceRating ? 'Edit rating' : 'Add rating'"
            >
              {{ row.performanceRating ? 'Edit' : 'Add' }}
            </button>
          </td>
          <td class="col-comments">
            <ng-container *ngIf="row.comments && row.comments.length > 0; else noComments">
              <div class="comment-item" *ngFor="let c of row.comments">{{ c }}</div>
            </ng-container>
            <ng-template #noComments><span class="muted">—</span></ng-template>
          </td>
          <td class="col-submitted">
            <span *ngIf="row.submittedDate; else noDate">{{ row.submittedDate | date: 'dd-MMM-yyyy' }}</span>
            <ng-template #noDate><span class="muted">—</span></ng-template>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="empty" *ngIf="!loading && !loadError && filteredRows.length === 0">
      No feedback entries for this scope.
    </div>
  </div>

  <!-- Pagination footer — client-side; keeps the DOM small when the manager
       has hundreds of reports. Rows-per-page is user-selectable. -->
  <div class="pagination-bar" *ngIf="!loading && !loadError && filteredRows.length > 0">
    <div class="pagination-bar__info">
      Showing <strong>{{ pageStart }}</strong>–<strong>{{ pageEnd }}</strong>
      of <strong>{{ filteredRows.length }}</strong>
    </div>
    <div class="pagination-bar__controls">
      <label class="page-size-label">
        Rows per page:
        <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}</option>
        </select>
      </label>
      <button
        type="button"
        class="page-btn"
        [disabled]="currentPage <= 1"
        (click)="goToPage(1)"
        aria-label="First page"
      >«</button>
      <button
        type="button"
        class="page-btn"
        [disabled]="currentPage <= 1"
        (click)="goToPage(currentPage - 1)"
        aria-label="Previous page"
      >‹</button>
      <span class="page-indicator">
        Page <strong>{{ currentPage }}</strong> of <strong>{{ totalPages }}</strong>
      </span>
      <button
        type="button"
        class="page-btn"
        [disabled]="currentPage >= totalPages"
        (click)="goToPage(currentPage + 1)"
        aria-label="Next page"
      >›</button>
      <button
        type="button"
        class="page-btn"
        [disabled]="currentPage >= totalPages"
        (click)="goToPage(totalPages)"
        aria-label="Last page"
      >»</button>
    </div>
  </div>
</div>

<!-- Contractor-profile modal — opened when the manager clicks Add / Edit
     on a row. Hosts the full quarterly-feedback form (rating dropdown +
     comments), so the manager can add or edit without leaving the page. -->
<app-modal-wrapper [showModal]="showContractorProfileModal">
  <app-contractor-profile
    *ngIf="showContractorProfileModal"
    [contractorId]="selectedContractorId"
    (close)="onContractorProfileClose()"
    [navigationSourceTeam]="'team-composition'"
  ></app-contractor-profile>
</app-modal-wrapper>
